import React, { useState } from "react";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRocket, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import Endpoints from "../../utils/repository/Endpoints";
import { Link } from "react-router-dom";
import { updateSubscriptionId } from "../Login/loginSlice";
import { PostRequest } from "../../utils/repository/RequestMaker";

const PlanCard = ({ plan, price, period, planId, clientId }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [approveModelIsOpen, setApproveModelIsOpen] = useState(false);
  const user = useSelector((state) => state.login.user);
  const dispatch = useDispatch();

  const handleApprove = async (data, actions) => {
    setModalIsOpen(false);

    if (data.orderID !== null) {
      try {
        const response = await PostRequest(
          { subscriptionId: data.subscriptionID },
          "/assign_subscription"
        );
        if (response.status === 200) {
          console.log("Subscription assigned to user");
          dispatch(updateSubscriptionId(data.subscriptionID));
        }
      } catch (error) {
        console.error("Error creating subscription:", error);
        setError(error);
      }
    }

    try {
      const response = await axios.get(
        `${Endpoints.verify_subscription}/${data.subscriptionID}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response.status === 200) {
        console.log("Subscription verified and saved");
        const customId = JSON.parse(response.data.custom_id);
        console.log(customId.report_limit);
        dispatch(updateSubscriptionId(data.subscriptionID));
      }
    } catch (error) {
      console.error("Error creating subscription:", error);
      setError(error);
    }
    console.log(data);
    setApproveModelIsOpen(true);
  };

  const closeApproveModal = () => {
    setApproveModelIsOpen(false);
  };

  const handleLoad = () => {
    setIsLoading(false);
  };

  const handleError = (err) => {
    setError(err);
    console.error("PayPal SDK failed to load", err);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setError("");
  };

  const openModal = () => {
    setModalIsOpen(true);
  };

  const createSubscription = async (data, actions) => {
    try {
      const response = await axios.post(
        Endpoints.create_subscription,
        {
          planId: planId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      console.log(response.data);
      return response.data.id;
    } catch (error) {
      console.error("Error creating subscription:", error);
      setError(error);
    }
  };

  return (
    <>
      <div className="col-md-3">
        <div className="card">
          <div className="card-header d-flex justify-content-center">
            <h6 className="m-3">{plan[0].name}</h6>
          </div>
          <div className="card-body m-3">
            {plan.length > 0 && (
              <div className="d-flex justify-content-between">
                <FontAwesomeIcon className="icon-css" icon={faRocket} />
                <div className="text-right">
                  <h3>{`€${parseFloat(plan[0].price).toFixed(
                    2
                  )}/${period}`}</h3>
                  <p>{plan[0].description}</p>
                </div>
              </div>
            )}
          </div>
          <div className="card-footer d-flex justify-content-center">
            <button type="button" className="btn btn-css" onClick={openModal}>
              Subscribe
            </button>
          </div>
        </div>
        <div>
          {modalIsOpen && (
            <div
              className="modal"
              style={{
                display: "block",
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 1000,
              }}
            >
              <div
                className="modal-dialog"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  right: "auto",
                  bottom: "auto",
                  marginRight: "-50%",
                  transform: "translate(-50%, -50%)",
                  width: "50%",
                  backgroundColor: "white",
                  maxHeight: "80%",
                  overflow: "auto",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                  zIndex: 1000,
                }}
              >
                <div className="modal-content">
                  <div className="modal-header d-flex justify-content-center">
                    <h6 className="modal-title">Abonnieren Sie mit PayPal</h6>
                  </div>
                  <div className="modal-body d-flex justify-content-center">
                    <PayPalScriptProvider
                      options={{
                        "client-id": clientId,
                        vault: true,
                        disableFunding: "card",
                        intent: "subscription",
                        currency: "EUR",
                      }}
                    >
                      <PayPalButtons
                        style={{
                          layout: "vertical",
                          color: "white",
                          shape: "pill",
                          label: "subscribe",
                          tagline: false,
                        }}
                        createSubscription={createSubscription}
                        onApprove={handleApprove}
                        onError={handleError}
                        onCancel={closeModal}
                        onButtonReady={handleLoad}
                      />
                    </PayPalScriptProvider>
                  </div>
                  <div className="modal-footer d-flex justify-content-center">
                    <button
                      type="button"
                      className="btn btn-css"
                      onClick={closeModal}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div>
          {approveModelIsOpen && (
            <div
              className="modal"
              style={{
                display: "block",
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 1000,
              }}
            >
              <div
                className="modal-dialog"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  right: "auto",
                  bottom: "auto",
                  marginRight: "-50%",
                  transform: "translate(-50%, -50%)",
                  width: "50%",
                  backgroundColor: "white",
                  maxHeight: "80%",
                  overflow: "auto",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                  zIndex: 1000,
                }}
              >
                <div className="modal-content">
                  <div className="modal-header d-flex justify-content-center">
                    <h6 className="modal-title">Subscription approved</h6>
                  </div>
                  <div className="modal-body d-flex justify-content-center">
                    <FontAwesomeIcon
                      className="icon-css"
                      icon={faCheckCircle}
                    />
                  </div>
                  <div className="modal-footer d-flex justify-content-center">
                    <Link
                      to="/"
                      type="button"
                      className="btn btn-css"
                      onClick={closeApproveModal}
                    >
                      Close
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PlanCard;
